import React from 'react'
import logo from '../../../assets/static/logo-expressodosul.png'

const LogotipoExpresso = () => <img src={logo} alt="Logotipo Expresso" />

export default LogotipoExpresso
